import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** 不動産リース */
enum RealEstateLease {
  realEstate = 'REAL_ESTATE',
  chattel = 'CHATTEL',
}

const nameConfig = {
  realEstate: new Map([
    [Locale.ja, '不動産リース'],
    [Locale.en, 'Real Estate'],
  ]),
  chattel: new Map([
    [Locale.ja, '動産リース'],
    [Locale.en, 'Chattel'],
  ]),
};

const toEnum = rawValueToEnum(RealEstateLease, RealEstateLease.realEstate);
const toDisplay = enumToName(RealEstateLease, nameConfig);

export const realEstateLease = {
  enum: RealEstateLease,
  nameConfig,
  toEnum,
  toDisplay,
};
export type { RealEstateLease };
